import { PaintedScene } from '../PaintedScene';

export const DRY_CANYON_PHASER_KEY = 'DryCanyonScene' as const;
export const DRY_CANYON_MANIFEST_KEY = 's-211-dry-canyon' as const;

export class DryCanyonScene extends PaintedScene {
  constructor() {
    super(DRY_CANYON_PHASER_KEY, DRY_CANYON_MANIFEST_KEY);
  }
}
